const Page = ({children}) => (
    <div>
        {children}
    </div>
)

export default Page